/** Shared entrance for Infinity contextual columns; respects reduced motion. */
export const contextColumnMotion = {
  animation: 'infinity-column-enter 220ms cubic-bezier(0.2, 0, 0, 1) both',
  '@keyframes infinity-column-enter': {
    from: { opacity: 0, transform: 'translateX(-20px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
};
